import Vue from "vue";
import "./plugins/vuetify";
import App from "./App.vue";
import router from "./router/index";
import store from "./store";
import axios from "axios";
import AuthPlugin from "@/api/AuthPlugin";
import Vuetify from "vuetify";
import "./plugins/vuelidate";

Vue.prototype.$apiRoot = process.env.VUE_APP_API_URL;
//Vue.prototype.$apiRoot = "https://localhost:44376/api/";
//Vue.prototype.$apiRoot = "http://localhost:61932/api/";
const base = axios.create({
  baseURL: Vue.prototype.$apiRoot
});

Vue.prototype.$http = base;

Vue.use(Vuetify, {
  theme: {
    primary: "#5c6366"
  }
});

Vue.use(AuthPlugin);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
